import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";

import {
  getLicensesSubscriptionList,
  getLicensesSubscriptionProductList,
  requestSubscriptionLicensesOrderPreview,
  requestSubscriptionLicensesOrderPreviewSuccess,
  unassignLicenseFromUser,
  unassignLicenseFromUserSuccess,
  updateSubscriptionLicensesOrder,
  updateSubscriptionLicensesOrderSuccess,
} from "../../../../store/manageLicense/action";
import {
  dateFormatReverse,
  timeFormatDateAndTimeNoSeconds,
} from "../../../../Components/Common/HandleDateTime";
import TableContainer from "../../../../Components/Common/TableContainer";
import getStaffInitials from "../../../../Components/Common/getStaffInitials";
import LoadingSpinner from "../../../../Components/Common/Spinner";
import Summary from "./summary";
import Select from "react-select";
import ConfirmNewLicenses from "../../../../Components/popUpComponents/ConfirmNewLicenses";
import { getStaffList } from "../../../../store/staff/action";
import { toast } from "react-toastify";
import Flatpickr from "react-flatpickr";
import AddNewLicense from "../../../../Components/popUpComponents/AddNewLicense";
import SendUserInvitation from "../../../../Components/popUpComponents/SendUserInvitation";
import SettingsPanel from "../../components/SettingsPanel";
// Change #100462 - Enterprise billing
import EnterpriseSeats, { isEnterpriseBilling } from "../../../../Components/popUpComponents/CreateEditCompanyUserLicenses/EnterpriseSeats";
import { subscriptionLicenceBillingApi } from "../../../../helpers/fakebackend_helper";
import RenewalWhen from "../../../../Components/Common/RenewalWhen";

export default function ManageLicense() {
  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState("1");

  const {
    GetSubscriptionList,
    GetSubscriptionListLoading,
    getLicensesSubscriptionProductListAPI,
  } = useSelector((state) => ({
    GetSubscriptionList:
      state.ManageLicense.licensesSubscriptionList?.subscriptionlicence_list,
    GetSubscriptionListLoading:
      state.ManageLicense.licenseSubscriptionListLoading,
    getLicensesSubscriptionProductListAPI:
      state.ManageLicense.licensesSubscriptionProductList
        ?.subscriptionproduct_list,
  }));
  const { staffData } = useSelector((state) => ({
    staffData: state.Staff.staffList?.staff_list,
  }));
  const [filteredSubscriptionProducts, setFilteredSubscriptionProducts] =
    useState([]);
  const [filter, setFilter] = useState("1");

  useEffect(() => {
    let filteredData = getLicensesSubscriptionProductListAPI;
    filteredData = getLicensesSubscriptionProductListAPI?.filter(
      (item) => item?.FlagTalkToSales === null
    );
    if (filter === "1") {
      filteredData = getLicensesSubscriptionProductListAPI?.filter(
        (item) => item?.SubscriptionLicenceDurationType_Id === "1"
      );
    }
    if (filter === "2") {
      filteredData = getLicensesSubscriptionProductListAPI?.filter(
        (item) => item?.SubscriptionLicenceDurationType_Id === "2"
      );
    }
    if (filter === "all") {
      filteredData = getLicensesSubscriptionProductListAPI;
    }
    filteredData = filteredData?.filter(
      (item) => item.FlagAllowFrontEndPurchase === "1"
    );
    setFilteredSubscriptionProducts(filteredData);
  }, [getLicensesSubscriptionProductListAPI, filter]);
  const [searchResults, setSearchResults] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [allowedSearchFilters, setAllowedSearchFilters] = useState(["Id"]);

  const [mobileMode, setMobileMode] = useState(false);

  useEffect(() => {
    dispatch(getLicensesSubscriptionList());
    dispatch(getLicensesSubscriptionProductList());
    dispatch(getStaffList());
    //check if the screen is mobile or not
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setMobileMode(true);
      } else {
        setMobileMode(false);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const licensesInitial = {
    SubscriptionProduct_Id: "",
    Quantity: 1,
    RenewalCycle: "Monthly",
  };
  const [licenses, setLicenses] = useState(licensesInitial);

  const [licenseTabs, setLicenseTabs] = useState([
    {
      id: "1",
      name: "All",
      licenseCount: 0,
    },
    {
      id: "2",
      name: "Assigned",
      licenseCount: 0,
    },
    {
      id: "3",
      name: "Unassigned",
      licenseCount: 0,
    },
  ]);

  useEffect(() => {
    if (isEmpty(GetSubscriptionList)) return;
    // update licenseCount for each tab
    setLicenseTabs((prev) => {
      return prev.map((item) => {
        return {
          ...item,
          licenseCount: GetSubscriptionList?.filter((license) => {
            if (item.id === "1") return true;
            if (item.id === "2") return !!license?.User_Id;
            if (item.id === "3") return !license?.User_Id;
          }).length,
        };
      });
    });
  }, [GetSubscriptionList]);
  // Subscription list column
  const handleLicensesUpdate = (Id, item, type) => {
    switch (type) {
      case "user":
        dispatch(
          updateSubscriptionLicensesOrder([
            {
              Id,
              User_Id: item.Id,
            },
          ])
        );
        break;
      case "unassign":
        dispatch(unassignLicenseFromUser([{ Id }]));
        break;
      case "expiryDate":
        dispatch(
          updateSubscriptionLicensesOrder([
            {
              Id,
              EndDateTime: !item
                ? item
                : timeFormatDateAndTimeNoSeconds(item)?.split(" ")[0],
            },
          ])
        );
        break;
      default:
        break;
    }
  };

  const { updateSubscriptionLicensesOrderAPI, unassignLicenseFromUserAPI } =
    useSelector((state) => ({
      updateSubscriptionLicensesOrderAPI:
        state.ManageLicense.updateSubscriptionLicensesOrder,
      unassignLicenseFromUserAPI: state.ManageLicense.unassignLicenseFromUser,
    }));
  useEffect(() => {
    if (isEmpty(updateSubscriptionLicensesOrderAPI)) return;
    if (updateSubscriptionLicensesOrderAPI.status === 200) {
      toast.success(updateSubscriptionLicensesOrderAPI.message);
      dispatch(getLicensesSubscriptionList());
    } else {
      toast.error(updateSubscriptionLicensesOrderAPI.message);
      dispatch(getLicensesSubscriptionList());
    }
    dispatch(updateSubscriptionLicensesOrderSuccess([]));
  }, [updateSubscriptionLicensesOrderAPI]);

  //updateSubscriptionLicensesOrderAPI
  useEffect(() => {
    if (isEmpty(unassignLicenseFromUserAPI)) return;
    if (unassignLicenseFromUserAPI.status === 200) {
      toast.success(unassignLicenseFromUserAPI.message);
      dispatch(getLicensesSubscriptionList());
    } else {
      toast.error(unassignLicenseFromUserAPI.message);
    }
    dispatch(unassignLicenseFromUserSuccess([]));
  }, [unassignLicenseFromUserAPI]);
  const columns = useMemo(
    () => [
      {
        Header: "License Name",
        accessor: "SubscriptionProduct_Name",
      },

      {
        Header: "Assigned to",
        accessor: "User_Id",
        //accessor status is  joblist.JobStatus_Id jobStatus.ID jobStatus.Name
        Cell: (license) => {
          return (
            <div>
              <UncontrolledDropdown>
                <DropdownToggle tag="button" className="btn ">
                  {staffData?.find(
                    (item) => item.Id === license.row.original?.User_Id
                  ) ? (
                    <div className={"staff-avatar-and-name-container"}>
                      {staffData?.find(
                        (item) => item.Id === license.row.original?.User_Id
                      ).ImageUrl ? (
                        <div>
                          <img
                            src={
                              staffData?.find(
                                (item) =>
                                  item.Id === license.row.original?.User_Id
                              )?.ImageUrl
                            }
                            alt=""
                            className="img-fluid rounded-circle avatar-xxs"
                          />
                          <span>
                            {" "}
                            {staffData?.find(
                              (item) =>
                                item.Id === license.row.original?.User_Id
                            )?.FirstName +
                              " " +
                              staffData?.find(
                                (item) =>
                                  item.Id === license.row.original?.User_Id
                              )?.LastName}
                          </span>
                        </div>
                      ) : (
                        <div className={"staff-avatar-and-name-container"}>
                          <span
                            className="
                            avatar-title avatar-xxs
                            rounded-circle bg-soft-primary
                             text-primary
                             Staff-single-letter-avatar
                              "
                          >
                            {getStaffInitials(
                              staffData?.find(
                                (item) =>
                                  item.Id === license.row.original?.User_Id
                              )
                            )}
                          </span>
                          <span>
                            {" "}
                            {staffData?.find(
                              (item) =>
                                item.Id === license.row.original?.User_Id
                            )?.FirstName +
                              " " +
                              staffData?.find(
                                (item) =>
                                  item.Id === license.row.original?.User_Id
                              )?.LastName}
                          </span>
                        </div>
                      )}
                      <span
                        title={"Unassign User from License"}
                        className={"ms-2 btn btn-danger btn-sm py-0 px-1"}
                        onClick={() => {
                          handleLicensesUpdate(
                            license.row.original?.Id,
                            "",
                            "unassign"
                          );
                        }}
                      >
                        {" "}
                        <i className=" fa-solid fa-user-xmark fs-10"></i>
                      </span>
                    </div>
                  ) : (
                    <div className={"staff-avatar-and-name-container"}>
                      <span
                        className="avatar-title rounded-circle
                         bg-soft-primary avatar-xxs text-primary
                          Staff-single-letter-avatar"
                      >
                        {" "}
                        U{" "}
                      </span>
                      <span>Unassigned</span>
                    </div>
                  )}
                </DropdownToggle>
                <DropdownMenu style={{ background: "#fff", minWidth: "300px" }}>
                  {!isEmpty(staffData) ? (
                    staffData.map((staff) => {
                      return (
                        <DropdownItem
                          key={staff.Id}
                          onClick={() => {
                            handleLicensesUpdate(
                              license.row.original?.Id,
                              staff,
                              "user"
                            );
                          }}
                          style={{ background: "#fff" }}
                        >
                          <div className="d-flex align-items-center">
                            {staff.ImageUrl ? (
                              <img
                                src={staff.ImageUrl}
                                alt=""
                                className="img-fluid rounded-circle avatar-xxs"
                              />
                            ) : (
                              <span
                                className="avatar-title
                                    align-items-center
                                    justify-content-center
                                  avatar-xxs rounded-circle
                                   bg-soft-primary text-primary
                                   single-email-staff-single-letter-time-entries
                                    "
                                style={{ minWidth: "25px" }}
                              >
                                {getStaffInitials(staff)}
                              </span>
                            )}
                            <div className="ms-3 d-flex align-items-center flex-wrap">
                              <span className={"me-1"}>
                                {staff?.FirstName}{" "}
                              </span>
                              <span>{staff?.LastName}</span>
                            </div>
                          </div>
                        </DropdownItem>
                      );
                    })
                  ) : (
                    <DropdownItem>No users Found</DropdownItem>
                  )}
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          );
        },
        filterable: false,
      },
      {
        Header: "License Price",
        accessor: "AmountLocalSubTotal",
        //accessor status is  joblist.JobStatus_Id jobStatus.ID jobStatus.Name
        Cell: (card) => {
          return (
            <div>
              {card.row.original?.AmountLocalSubTotal && (
                <span className={""}>
                  £ {card.row.original?.AmountLocalSubTotal}{" "}
                </span>
              )}
            </div>
          );
        },
        filterable: false,
      },
      {
        Header: "Next Renewal Date",
        accessor: "RenewalDateTime",
        //accessor status is  joblist.JobStatus_Id jobStatus.ID jobStatus.Name
        Cell: (item) => {
          return (
            <div>
              {/* Change #100463 - the date and "in N days" / "overdue by N days"
                  instead of just "Expired". */}
              <RenewalWhen at={item.row.original?.RenewalDateTime} />
            </div>
          );
        },
        filterable: false,
      },
      {
        Header: "Renewal Cycle",
        accessor: "SubscriptionLicenceDurationType_Name",
        //accessor status is  joblist.JobStatus_Id jobStatus.ID jobStatus.Name
        Cell: (card) => {
          return (
            <div>
              <span className={""}>
                {card.row.original?.SubscriptionLicenceDurationType_Name}{" "}
              </span>
            </div>
          );
        },
        filterable: false,
      },
      {
        Header: "Expiry Date",
        accessor: "EndDateTime",
        //accessor status is  joblist.JobStatus_Id jobStatus.ID jobStatus.Name
        Cell: (card) => {
          return (
            <div className={"d-flex flex-row"}>
              <span>
                <Flatpickr
                  name="date"
                  id="date-field"
                  className="form-control"
                  placeholder="Select a date"
                  options={{
                    altInput: true,
                    altFormat: "d, M, Y",
                    dateFormat: "Y-m-d",
                    defaultDate: [
                      new Date(
                        dateFormatReverse(card.row.original?.EndDateTime)
                      ),
                    ],
                  }}
                  value={
                    card.row.original?.EndDateTime &&
                    dateFormatReverse(card.row.original?.EndDateTime)
                  }
                  onClose={(date) => {
                    !isEmpty(date) &&
                      handleLicensesUpdate(
                        card.row.original?.Id,
                        date[0],
                        "expiryDate"
                      );
                  }}
                />
              </span>
              {/*  clear icon*/}{" "}
              {card.row.original?.EndDateTime && (
                <span
                  title={"Clear Date"}
                  className={
                    "btn btn-danger  d-flex align-items-center ps-2 pe-2 ms-1"
                  }
                  onClick={() => {
                    handleLicensesUpdate(
                      card.row.original?.Id,
                      "",
                      "expiryDate"
                    );
                  }}
                >
                  <i className={"ri-close-line"}></i>{" "}
                </span>
              )}
            </div>
          );
        },
        filterable: false,
      },
    ],
    [staffData]
  );
  useEffect(() => {
    let filteredCustomerList = GetSubscriptionList;

    const timer = setTimeout(() => {
      if (activeTab === "1") {
        filteredCustomerList = filteredCustomerList?.filter((item) => item);
      }
      if (activeTab === "2") {
        filteredCustomerList = filteredCustomerList?.filter((item) => {
          return !!item?.User_Id;
        });
      }
      if (activeTab === "3") {
        filteredCustomerList = filteredCustomerList?.filter((item) => {
          return !item?.User_Id;
        });
      }
      filteredCustomerList = filteredCustomerList?.filter((item) => {
        return allowedSearchFilters.some((key) => {
          return (
            item[key] &&
            item[key]
              .toString()
              .toLowerCase()
              .includes(searchQuery?.toLowerCase())
          );
        });
      });

      setSearchResults(filteredCustomerList);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchQuery, GetSubscriptionList, activeTab]);

  // Change #100462 - an Enterprise company sees its seats and never buys licences.
  const [billing, setBilling] = useState(null);
  useEffect(() => {
    let alive = true;
    subscriptionLicenceBillingApi()
      .then((res) => {
        if (alive && res?.status === 200) setBilling(res.subscriptionbilling || null);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [GetSubscriptionList]);
  const isEnterprise = isEnterpriseBilling(billing);

  const [modalAddNewLicenses, setModalAddNewLicenses] = useState(false);
  const toggleAddNewLicenses = () =>
    setModalAddNewLicenses(!modalAddNewLicenses);
  const [modalSendUserInvitation, setModalSendUserInvitation] = useState(false);
  const toggleSendUserInvitation = () => {
    setModalSendUserInvitation(!modalSendUserInvitation);
  };

  return (
    <>
      {modalSendUserInvitation && (
        <SendUserInvitation
          modal={modalSendUserInvitation}
          toggle={toggleSendUserInvitation}
        />
      )}
      {modalAddNewLicenses && (
        <AddNewLicense
          modal={modalAddNewLicenses}
          toggle={toggleAddNewLicenses}
        />
      )}

      <SettingsPanel
        title="License Settings"
        description="Licences owned, assigned and available"
        tabs={licenseTabs.map((item) => ({
          value: item.id,
          label: item.name,
          count: item.licenseCount,
        }))}
        value={activeTab}
        onChange={setActiveTab}
      >
        {isEnterprise && (
          <div className={"mb-3"}>
            <EnterpriseSeats billing={billing} adding={0} />
          </div>
        )}
        <div>
          <Summary subscriptionListData={GetSubscriptionList} />
        </div>

        <Row className={"mt-2"}>
          <Col lg={12}>
            <Card id="customersList">
              <CardHeader className="border-0 ">
                <Row className="g-4 align-items-center">
                  <Col sm={3}>
                    <div className="search-box">
                      <Input
                        // create search with jobs List Data
                        type="search"
                        className="form-control search"
                        placeholder="Search for..."
                        onChange={(e) => setSearchQuery(e.target.value)}
                        value={searchQuery}
                      />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  </Col>
                  <div className="col-sm-auto ms-auto">
                    <div className={"d-flex"}>
                      <div
                        className="hstack gap-2 btn btn-primary me-2"
                        onClick={() => {
                          toggleSendUserInvitation();
                        }}
                      >
                        <i className="fa-regular fa-paper-plane me-1"></i>
                        Send New User Invitation
                      </div>
                      {!mobileMode && !isEnterprise && (
                        <div
                          className="hstack gap-2 btn btn-success"
                          onClick={toggleAddNewLicenses}
                        >
                          <i className="ri-add-line align-bottom me-1"></i>
                          Add New License
                        </div>
                      )}
                    </div>
                  </div>
                </Row>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  {GetSubscriptionListLoading ? (
                    <LoadingSpinner />
                  ) : (
                    <div>
                      {!isEmpty(searchResults) ? (
                        <TableContainer
                          columns={columns}
                          data={searchResults || []}
                          isGlobalFilter={false}
                          isAddUserList={false}
                          customPageSize={10}
                          className="custom-header-css"
                          divClass="table-responsive table-card mb-0"
                          tableClass="align-middle table-wrap"
                          theadClass="text-muted"
                          // handleLeadClick={handleLeadClicks}
                          isLeadsFilter={false}
                        />
                      ) : (
                        <div>You currently have no active licenses</div>
                      )}
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </SettingsPanel>
    </>
  );
}
